"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskEntityManager = exports.findTaskEntity = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
function findTaskEntity(taskId, params = {}) {
    const request = core_ui_1.api.get(`tasks/${taskId}/task-entity`, params);
    return { request, result: (0, core_ui_1.apiResolve)(request) };
}
exports.findTaskEntity = findTaskEntity;
// get and cache task entities
function useTaskEntityManager() {
    const itemsRef = (0, react_1.useRef)([]);
    const [items, setItems] = (0, react_1.useState)([]);
    const addItem = (0, react_1.useCallback)((taskId, entity) => {
        const newItem = { taskId, entity };
        setItems(items => {
            const index = items.findIndex(item => item.taskId === taskId);
            const copy = Array.from(items);
            if (index < 0) {
                copy.push(newItem);
            }
            else {
                copy.splice(index, 1, newItem);
            }
            itemsRef.current = copy;
            return copy;
        });
        return entity;
    }, []);
    const load = (0, react_1.useCallback)((taskId, params = {}) => __awaiter(this, void 0, void 0, function* () {
        const { data: entity } = yield findTaskEntity(taskId, params).result;
        entity && addItem(taskId, entity);
        return entity;
    }), [addItem]);
    const find = (0, react_1.useCallback)((taskId) => {
        var _a;
        return (_a = items.find(item => item.taskId === taskId)) === null || _a === void 0 ? void 0 : _a.entity;
    }, [items]);
    const findAsync = (0, react_1.useCallback)((taskId, params) => __awaiter(this, void 0, void 0, function* () {
        const item = itemsRef.current.find(item => item.taskId === taskId);
        if (item === null || item === void 0 ? void 0 : item.entity) {
            return item.entity;
        }
        const { data: entity } = yield findTaskEntity(taskId, params).result;
        return entity && addItem(taskId, entity);
    }), [addItem]);
    const manager = (0, react_1.useMemo)(() => {
        return { find, findAsync, load };
    }, [find, findAsync, load]);
    return manager;
}
exports.useTaskEntityManager = useTaskEntityManager;
//# sourceMappingURL=useTaskEntityManager.js.map